import script from "./MembroDetalhesModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MembroDetalhesModal.vue?vue&type=script&setup=true&lang=js"

import "./MembroDetalhesModal.vue?vue&type=style&index=0&id=2c9a11a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c9a11a8"]])

export default __exports__